import { DictData, DictTemplateCodeEnum } from '@/pages/documentCompile/dict/type';

export const TemplateCode = DictTemplateCodeEnum.ENTERPRISE_ATTR